// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"9de2e369","356":"9de2e369","601":"9de2e369","741":"010d82a6","934":"7e398dba"}[chunkId] + ".chunk.css";
};